module.exports = __webpack_public_path__ + "static/img/truck-station_256.f7343ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/truck-station_256.png
// module id = BkUR
// module chunks = 0